const block = {
  $el: document.querySelector('section.search_results'),
  init() {
    if (this.$el) {
      this.setUpListeners();
    }
  },

  setUpListeners() {
    const $loadMore = this.$el.querySelector('.load_more');

    if ($loadMore) {
      $loadMore.addEventListener('click', this.loadMore.bind(this));
    }
  },

  loadMore({currentTarget}) {
    const postsPerPage = +currentTarget.dataset.postsPerPage;
    const page = +currentTarget.dataset.page;

    const data = {
      action: 'tjh_search_load_more',
      search_query: new URLSearchParams(window.location.search).get('s'),
      page
    };

    if (tjh.lang) {
      data.lang = tjh.lang;
    }

    fetch(tjh.ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(data)
    })
    .then(response => response.text()) // or .json() if expecting JSON
    .then(response => {
      if (response) {
        const $grid = this.$el.querySelector('.results_grid');
        const $tempDiv = document.createElement('DIV');

        $tempDiv.innerHTML = response;

        const $newPosts = $tempDiv.querySelectorAll('a.item');

        $newPosts.forEach($post => {
          $grid.appendChild($post); // Append each post individually
        });

        if ($newPosts.length < postsPerPage) {
          currentTarget.classList.remove('active');
        }

        currentTarget.dataset.page = page + 1;
      } else {
        // Handle case where there's no response
        console.log('No response');
        currentTarget.classList.remove('active');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      currentTarget.classList.remove('active');
    });
  }
};

export default block;